import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-3">
      <ol className="flex items-center gap-1.5 text-sm flex-wrap">
        <li>
          <Link to="/" className="text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">
            <span className="w-4 h-4 inline-flex items-center justify-center">
              <i className="ri-home-4-line"></i>
            </span>
            <span className="ml-1">首页</span>
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1.5">
            <span className="text-foreground-300">
              <span className="w-3 h-3 inline-flex items-center justify-center">
                <i className="ri-arrow-right-s-line"></i>
              </span>
            </span>
            {item.href ? (
              <Link to={item.href} className="text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-950 font-medium whitespace-nowrap">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}